import React from 'react';

// Toggle — accessible pill switch.
//
// role="switch" + aria-checked is the canonical pattern for binary state;
// using a real <button> gives us free keyboard handling (Space + Enter both
// fire onClick) and native focus management. The visual is a 36×22 dark
// pill with an 18-px white knob that slides between left and right.
//
// stopPropagation in the click handler so the parent design card can
// remain clickable without the toggle accidentally opening the preview.

const Toggle = ({
  on,
  onChange,
  ariaLabel = 'Toggle',
  size = 'md',
  disabled = false,
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (!disabled) onChange(!on);
  };
  const handleKey = (e) => {
    // Real <button> already handles Enter + Space, but we stop propagation
    // so the card doesn't also fire its keyboard activation.
    if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
  };
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      className={`v2-toggle v2-toggle--${size} ${on ? 'on' : 'off'} ${disabled ? 'is-disabled' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKey}
      disabled={disabled}
    >
      <span className="v2-toggle-knob" aria-hidden />
    </button>
  );
};

export default Toggle;
